import React from 'react'
import { arrayOf, bool, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useContainerWidth, H3 } from '@fs/zion-ui'
import Quiz from './Quiz'
import ComparisonPanel from '../ComparisonPanel/ComparisonPanel'
import { SOLID, NONE } from '../ComparisonPanel/ComparisonPanelBackgroundTypes'
import { useDSCState } from '../../../../../state/DSCStore'
import { useAamState } from '../../../state/AamStore'
import { getGender } from '../../../../../shared/helpers/person_Helper'
import { useComparisonByYear } from '../../../hooks/hooks'

export default function QuizComparison({
  id,
  imageUrl,
  header,
  comparisonTargetPerson,
  tileContentData,
  tileComparisonContent,
  year,
  comparisonYear,
  headingWithIcon,
  tileData,
}) {
  const atWidth = useContainerWidth()
  const dscState = useDSCState()
  const aamState = useAamState()
  const showComparison = useComparisonByYear(aamState, comparisonTargetPerson, dscState, tileData, comparisonYear)

  const quizzesContainerStyle = css`
    display: flex;
    justify-content: center;
    align-items: ${atWidth({ default: 'center', lg: '' })};
    width: 100%;
    flex-direction: ${atWidth({ default: 'column-reverse', lg: 'row' })};
    margin-top: ${atWidth({ default: '10px', lg: '20px' })};
  `

  const background = showComparison ? SOLID : NONE // Don't show a background if there isn't a comparisonTarget, or the comparisonTarget is the user

  return (
    <>
      <div css={{ padding: '10px' }}>
        {(!comparisonYear || comparisonYear === tileData?.year) && <H3 centered>{tileData.year}</H3>}
        <H3 centered>{headingWithIcon}</H3>
      </div>
      <div css={quizzesContainerStyle}>
        <ComparisonPanel gender={tileData?.gender?.toLowerCase()} background={background}>
          <Quiz
            year={year}
            id={id}
            tileContentData={tileContentData}
            quiz={tileContentData?.[0]}
            imageUrl={imageUrl}
            header={header}
            styling={{ padding: '10px' }}
            person={{ atn: tileData.atn, dob: year }}
            gender={tileData?.gender?.toLowerCase()}
            twoColumnQuestions={!showComparison}
            showPersonBlock={showComparison}
          />
        </ComparisonPanel>
        {showComparison && (
          <ComparisonPanel
            gender={
              comparisonTargetPerson?.gender
                ? comparisonTargetPerson?.gender.toLowerCase()
                : getGender(comparisonTargetPerson?.genderType)
            }
            background={SOLID}
          >
            <Quiz
              id={id}
              year={comparisonYear}
              quiz={tileComparisonContent?.[0]}
              imageUrl={imageUrl}
              header={header}
              styling={{ padding: '10px' }}
              gender={
                comparisonTargetPerson?.gender
                  ? comparisonTargetPerson?.gender.toLowerCase()
                  : getGender(comparisonTargetPerson?.genderType)
              }
              thumbnailIcon={comparisonTargetPerson?.portraitThumbnailLink ?? ''}
              person={comparisonTargetPerson}
              showPersonBlock
            />
          </ComparisonPanel>
        )}
      </div>
    </>
  )
}
QuizComparison.propTypes = {
  tileContentData: arrayOf(
    shape({
      answerText: string,
      answers: string,
      id: number,
      language: string,
      quizType: string,
      region: string,
      text: string,
      text1: string,
      text2: string,
      text3: string,
      text4: string,
      year: number,
    })
  ),
  id: number,
  imageUrl: string,
  header: string,
  comparisonTargetPerson: shape({
    active: bool,
    atn: string,
    displayName: string,
    dob: string,
    gender: string,
    genderType: string,
    lifespan: string,
    living: bool,
    name: string,
    personId: string,
    surname: string,
  }),
  // tileComparisonContent,
  year: number,
  comparisonYear: number,
  headingWithIcon: shape({}),
  tileData: shape({
    personId: string,
    gender: string,
  }),
}
